<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('evaluationDelete') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <!-- <label v-if="this.$parent.evaluationNotEmpty" class="form-label">{{ $t('evaluationNotEmpty') }}</label>
                    <template v-else-if="this.$parent.foundEvaluations.length > 0">
                        <label class="form-label">{{ $t('cannotDeleteEvaluation') }}</label>
                        <div v-for="(evaluation, i) in this.$parent.foundEvaluations" :key="i">
                            <RouterLink :to="'/modeling/' + this.$route.params.id + '/modelingresult/' + evaluation.resultId ">
                                {{ evaluation.name }} - Id: {{evaluation.resultId}}
                            </RouterLink>
                        </div>
                    </template>
                    <p v-else></p> -->
                    {{ $t('wannaDeleteThisEvaluation') }}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <!-- :disabled="this.$parent.foundEvaluations.length > 0 || this.$parent.evaluationNotEmpty" -->
                    <button type="button" class="btn btn-primary" @click="deleteEvaluation" >
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import EvaluationApi from "../../api/server/evaluation.js";

export default {
    name: "evaluationDeleteModal",
    methods: {
        close() {
            this.$emit("closeDeleteDialog");
        },
        async deleteEvaluation() {
            await EvaluationApi.evaluationDelete(this.$parent.$route.params.id, this.$parent.evaluationToDeleteId);
            this.$emit("closeDeleteDialog");
            this.$emit("reload");
        }
    }
}
</script>